/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ListMerchantsResponse,
    ListMerchantsResponseFromJSON,
    ListMerchantsResponseToJSON,
} from '../models';

export interface PostMerchantsListRequest {
    body?: any | null;
}

/**
 * 
 */
export class MerchantsApi extends runtime.BaseAPI {

    /**
     */
    async postMerchantsListRaw(requestParameters: PostMerchantsListRequest): Promise<runtime.ApiResponse<ListMerchantsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // CognitoAuthorizer authentication
        }

        const response = await this.request({
            path: `/merchant/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ListMerchantsResponseFromJSON(jsonValue));
    }

    /**
     */
    async postMerchantsList(requestParameters: PostMerchantsListRequest): Promise<ListMerchantsResponse> {
        const response = await this.postMerchantsListRaw(requestParameters);
        return await response.value();
    }

}
